import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ArticleCard from '@/components/base/ArticleCard';
import ReviewCard from '@/components/base/ReviewCard';
import { articles, featuredArticles, categories } from '@/mocks/articles';
import { reviews } from '@/mocks/reviews';
import { Link } from 'react-router-dom';

export default function Home() {
  return (
    <>
      <Navbar />

      <main>
        {/* Hero Section */}
        <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden">
          <div className="absolute inset-0">
            <img
              src="https://readdy.ai/api/search-image?query=A%20stylized%20dramatic%20illustration%20of%20breaking%20news%20and%20social%20media%20trending%20topics%2C%20modern%20editorial%20digital%20art%20with%20dark%20background%2C%20vibrant%20coral%20and%20lime%20green%20accent%20lights%2C%20abstract%20newsroom%20vibe%2C%20dynamic%20energy%2C%20gossip%20and%20entertainment%20news%20concept%2C%20bold%20graphic%20composition%2C%20trending%20hot%20topics%20visual%20metaphor&width=1800&height=900&seq=home-hero-bg&orientation=landscape"
              alt="52吃瓜网 - 最新吃瓜爆料"
              title="52吃瓜网首页背景"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-foreground-900/50 via-foreground-900/30 to-foreground-900/60"></div>
          </div>
          <div className="relative w-full max-w-7xl mx-auto px-4 md:px-6">
            <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
              <div className="lg:w-5/12 text-center lg:text-left pt-24 md:pt-0">
                <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-black text-background-50 leading-tight mb-6">
                  吃瓜爆料<span className="italic text-accent-400">每日追踪</span>
                  <br />
                  一手资讯尽在掌握
                </h1>
                <p className="text-base md:text-lg text-background-200 leading-relaxed mb-8 max-w-lg mx-auto lg:mx-0">
                  52吃瓜网每日实时更新网红塌房、娱乐圈爆料、黑料八卦等热门内容，做你最忠实的吃瓜伙伴。官网入口、APP下载，随时随地吃瓜不停歇。
                </p>
                <div className="flex flex-col sm:flex-row gap-3 justify-center lg:justify-start">
                  <Link
                    to="/category/chigua-qianxian"
                    className="px-8 py-3.5 bg-primary-500 text-background-50 font-semibold text-sm rounded-full hover:bg-primary-600 transition-all cursor-pointer whitespace-nowrap text-center"
                  >
                    立即吃瓜
                  </Link>
                  <a
                    href="#download"
                    className="px-8 py-3.5 border-2 border-background-50/30 text-background-50 font-semibold text-sm rounded-full hover:border-background-50 hover:bg-background-50/10 transition-all cursor-pointer whitespace-nowrap text-center"
                  >
                    下载APP
                  </a>
                </div>
              </div>
              <div className="lg:w-7/12 w-full">
                <img
                  src="https://readdy.ai/api/search-image?query=A%20modern%20stylized%20illustration%20of%20a%20smartphone%20displaying%20trending%20gossip%20news%20feed%20with%20vibrant%20coral%20red%20and%20lime%20green%20notifications%2C%20social%20media%20app%20interface%20concept%2C%20editorial%20digital%20art%2C%20clean%20modern%20design%2C%20dark%20phone%20frame%20with%20colorful%20content%2C%20entertainment%20news%20app%20mockup%2C%20breaking%20news%20alerts&width=900&height=600&seq=home-hero-visual&orientation=landscape"
                  alt="52吃瓜网APP界面"
                  title="52吃瓜网APP - 随时随地吃瓜"
                  className="w-full rounded-3xl"
                />
              </div>
            </div>
          </div>
        </section>

        {/* Schema.org WebPage */}
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              '@context': 'https://schema.org',
              '@type': 'WebPage',
              name: '52吃瓜网首页 - 吃瓜爆料黑料每日实时更新',
              description:
                '52吃瓜网最新消息与官网入口，涵盖52吃瓜爆料、黑料吃瓜网等热门内容，为用户提供吃瓜爆料每日追踪与实时更新。',
              url: 'http://rdstudio.cn/',
              breadcrumb: {
                '@type': 'BreadcrumbList',
                itemListElement: [
                  {
                    '@type': 'ListItem',
                    position: 1,
                    name: '首页',
                    item: 'http://rdstudio.cn/',
                  },
                ],
              },
            }),
          }}
        />

        {/* Feature Grid - Categories */}
        <section className="py-16 md:py-24 bg-background-100">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="text-center mb-12 md:mb-16">
              <p className="text-sm text-foreground-400 font-medium tracking-wide mb-3">
                热门分类
              </p>
              <h2 className="text-3xl md:text-5xl font-heading font-black text-foreground-900 leading-tight">
                你想吃的瓜
                <br />
                这里全都有
              </h2>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="group bg-background-50 rounded-2xl p-6 md:p-8 transition-all duration-300 hover:scale-[1.02] cursor-pointer"
                >
                  <div className="w-12 h-12 md:w-14 md:h-14 rounded-xl bg-primary-100/70 flex items-center justify-center mb-5">
                    <i className="ri-fire-line text-primary-500 text-xl md:text-2xl"></i>
                  </div>
                  <h3 className="text-lg md:text-xl font-heading font-bold text-foreground-900 mb-3">
                    {cat.name}
                  </h3>
                  <p className="text-sm text-foreground-500 leading-relaxed">
                    {cat.description}
                  </p>
                </Link>
              ))}
            </div>
          </div>
        </section>

        {/* Featured Article */}
        <section className="py-12 md:py-16 bg-background-50">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <ArticleCard article={featuredArticles[0]} variant="featured" />
          </div>
        </section>

        {/* Grid - Latest Articles */}
        <section className="py-16 md:py-24 bg-background-50">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-4 mb-12">
              <div>
                <p className="text-sm text-foreground-400 font-medium tracking-wide mb-2">
                  最新爆料
                </p>
                <h2 className="text-2xl md:text-4xl font-heading font-black text-foreground-900">
                  吃瓜<span className="italic text-primary-500 font-heading">前线</span>
                </h2>
              </div>
              <p className="text-sm md:text-base text-foreground-500 leading-relaxed lg:max-w-md">
                每日实时更新最新吃瓜爆料内容，涵盖网红塌房、娱乐圈猛料、黑料实锤等热门话题，让你不错过任何一颗大瓜。
              </p>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
              {articles.slice(1, 7).map((article, idx) => (
                <ArticleCard
                  key={article.id}
                  article={article}
                  variant={idx === 1 ? 'featured' : 'default'}
                />
              ))}
            </div>
            <div className="text-center mt-10">
              <Link
                to="/category/chigua-qianxian"
                className="inline-flex items-center gap-2 px-8 py-3 bg-secondary-500 text-foreground-950 font-semibold text-sm rounded-full hover:bg-secondary-400 transition-colors cursor-pointer whitespace-nowrap"
              >
                查看更多 <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </div>
        </section>

        {/* Reviews */}
        <section className="py-16 md:py-24 bg-background-100">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="text-left mb-12">
              <span className="inline-block px-4 py-1.5 bg-secondary-100 text-secondary-800 text-xs font-semibold rounded-full mb-4 whitespace-nowrap">
                瓜友热评
              </span>
              <h2 className="text-3xl md:text-5xl font-heading font-black text-foreground-900 leading-tight mb-4">
                吃瓜群众们
                <br />
                都在说什么
              </h2>
            </div>
            <div className="columns-1 sm:columns-2 lg:columns-3 gap-5">
              {reviews.map((review) => (
                <ReviewCard key={review.id} review={review} />
              ))}
            </div>
          </div>
        </section>

        {/* CTA - App Download */}
        <section id="download" className="relative w-full min-h-[500px] md:min-h-[560px] flex items-center overflow-hidden">
          <div className="absolute inset-0">
            <img
              src="https://readdy.ai/api/search-image?query=A%20warm%20stylized%20illustration%20of%20people%20gathering%20and%20sharing%20news%20on%20their%20phones%2C%20community%20and%20social%20connection%20concept%2C%20modern%20editorial%20digital%20art%2C%20warm%20coral%20and%20amber%20tones%2C%20cozy%20atmosphere%2C%20friendly%20social%20interaction%2C%20evening%20mood%20lighting%2C%20digital%20lifestyle&width=1800&height=700&seq=home-cta-bg&orientation=landscape"
              alt="下载52吃瓜网APP"
              title="52吃瓜网APP下载"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-foreground-900/55"></div>
          </div>
          <div className="relative w-full max-w-2xl mx-auto px-4 md:px-6 text-center py-20">
            <h2 className="text-3xl md:text-5xl font-heading font-black text-background-50 leading-tight mb-4">
              下载52吃瓜网APP
            </h2>
            <p className="text-base md:text-lg text-background-200 leading-relaxed mb-8 max-w-md mx-auto">
              随时随地追踪最新吃瓜爆料，推送及时、内容独家，<br />绝不错过任何一个大瓜。
            </p>
            <a
              href="#download"
              className="inline-flex items-center gap-3 px-8 py-4 bg-foreground-950 text-background-50 font-semibold text-sm rounded-full hover:bg-foreground-900 transition-all cursor-pointer whitespace-nowrap"
            >
              <span className="w-8 h-8 rounded-full bg-primary-500 flex items-center justify-center shrink-0">
                <i className="ri-download-2-line text-background-50 text-sm"></i>
              </span>
              立即下载APP
              <i className="ri-arrow-right-up-line ml-1"></i>
            </a>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}